import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Remove hash from URL if present
if (window.location.hash === '#' || window.location.hash === '#/') {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
